/**
 * (c) 2015 Ignite Sales, Inc.
 * User: aholmes
 * Date: 6/23/2016
 * Time: 3:03 PM
 */

export function getLocale() {
  let locale = navigator.language || 'en';
  const languageParts = locale.split('-');

  if (languageParts.length) {
    locale = languageParts[0];
  }

  return locale;
}



/** WEBPACK FOOTER **
 ** ./src/main/js/common/i18n/Locale.js
 **/